import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import c from 'state/constants'

import Inbox from './inbox'
import Outbox from './outbox'
import News from './news'
import Agenda from './agenda'
import TaskList from './taskList'
import Links from './links'
import Claims from './claims'
import Faq from './faq'
import Office from './office'
import Clients from './clients'
import B2b from './b2b'
import InsuranceCompany from './b2bCompany'
import Webapps from './webapps'
import EmailDocument from './emailDocument'
import WillDoc from './willdoc'
import DSDocuments from './DSDocuments'

const Production = () => {
    window.open('https://ts.ovb-willemot.be/37b8677ecc305f783ac786b56d34b93250f3b2dd4b66b1bac78472bb36087d03ca3313fbf3735e8', '_blank', 'noopener,noreferrer')
    return <div/>
}

@connect(state => ({
	module: state.app.module,
}))
export default class Content extends Component {
	static propTypes = {
		className: PropTypes.string,
		module: PropTypes.string.isRequired,
	}
	render() {
		const {module} = this.props
		let output
		switch (module) {
			case c.INBOX:
				output = <Inbox/>
                break
            case c.OUTBOX:
				output = <Outbox/>
				break
			case c.TASKLIST:
				output = <TaskList/>
				break
			case c.NEWS:
				output = <News/>
				break
			case c.LINKS:
				output = <Links/>
				break
			case c.FAQ:
				output = <Faq/>
				break
			case c.OFFICE:
				output = <Office/>
				break
			case c.PRODUCTION:
				output = <Production/>
				break
			case c.B2B:
				output = <B2b/>
				break
			case c.INSURANCE_COMPANY:
			case c.PVVERZEKERINGENCVBA:
			case c.GENERALIBELGIUM:
				output = <InsuranceCompany/>
				break
			case c.AGENDA:
				output = <Agenda/>
				break
			case c.CLIENTS:
				output = <Clients/>
				break
			case c.CLAIMS:
				output = <Claims/>
				break
			case c.WILLDOC:
				output = <WillDoc/>
				break
			case c.WEBAPPS:
				output = <Webapps/>
                break
            case c.EMAILDOCUMENT:
				output = <EmailDocument/>
                break
            case c.DSDOCUMENTS:
				output = <DSDocuments/>
			break
			default:
				output = <div>Unknown module {module}</div>
				break
		}
		return output
	}
}



// WEBPACK FOOTER //
// ./components/content.jsx